import { Box } from "@mui/material";
import { DotLegalHeader } from "@dotlegal/dotlegal-ui-components";
import { useTranslation } from "../../localization/useTranslation";
import { AiUsageProgressBarViewModel } from "./AiUsageProgressBar.types";

export interface AiUsageProgressBarProps {
    limit: number;
    usage: AiUsageProgressBarViewModel;
    showLegend?: boolean;
}

function AiUsageProgressBar(props: AiUsageProgressBarProps) {
    const { translateString } = useTranslation();

    let runningTotal = 0;
    const segments = [
        { color: "#7284FA", amount: props.usage.contractCreations, label: translateString("aiContractCreation") },
        { color: "#9B8AFB", amount: props.usage.obligationExtractions, label: translateString("aiObligationExtraction") },
        { color: "#3DDCCE", amount: props.usage.documentScans, label: translateString("aiQualityScanOfDocuments") },
        { color: "#F7D2EC", amount: props.usage.chats, label: translateString("aiComplianceChat") },
    ]
        .sort((a, b) => b.amount - a.amount)
        .map((segment) => {
            runningTotal += segment.amount;
            return { ...segment, cumulative: runningTotal };
        });

    const totalUsage = runningTotal;

    return (
        <Box sx={{ marginRight: 6, marginLeft: 6 }}>
            <Box sx={{ display: "flex", justifyContent: "space-between" }}>
                <DotLegalHeader headerStyle="medium">{translateString("usage", { usage: totalUsage.toFixed(2) })}</DotLegalHeader>
                <DotLegalHeader headerStyle="medium">{translateString("limit", { limit: props.limit.toFixed(2) })}</DotLegalHeader>
            </Box>

            <Box sx={{ position: "relative", height: 20, borderRadius: 5, overflow: "hidden", backgroundColor: "#E4E7EC" }}>
                {segments.map((segment, index) => (
                    <Box
                        key={segment.label}
                        sx={{
                            position: "absolute",
                            top: 0,
                            bottom: 0,
                            left: 0,
                            width: `${(segment.cumulative / props.limit) * 100}%`,
                            backgroundColor: segment.color,
                            borderTopRightRadius: 10,
                            borderBottomRightRadius: 10,
                            zIndex: segments.length - index,
                        }}
                    />
                ))}
            </Box>

            {props.showLegend && (
                <Box sx={{ display: "flex", flexDirection: "column", gap: 0.5, marginTop: 2 }}>
                    {segments
                        .filter((segment) => segment.amount > 0)
                        .map((segment) => (
                            <Box key={segment.label} sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                                <Box sx={{ width: 12, height: 12, borderRadius: "50%", backgroundColor: segment.color, flexShrink: 0 }} />
                                <DotLegalHeader headerStyle="small" marginBottom={0} fontWeight={400}>
                                    {segment.label}: €{segment.amount.toFixed(2)}
                                </DotLegalHeader>
                            </Box>
                        ))}
                </Box>
            )}
        </Box>
    );
}

export default AiUsageProgressBar;
